var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatPasteGoBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "chat_paste_go"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3333_11311",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3333_11311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chat_paste_go_2",
    d: "M12.0001 14.35L10.8835 13.2333L11.8335 12.2833H9.2168V10.7166H11.8335L10.8835 9.76663L12.0001 8.64997L14.8501 11.5L12.0001 14.35ZM1.2168 14.6833V2.3833H12.9501V7.44997C12.7982 7.40186 12.6409 7.37036 12.478 7.35547C12.315 7.34069 12.1543 7.3333 11.996 7.3333C11.8932 7.3333 11.7904 7.3398 11.6876 7.3528C11.5849 7.36569 11.4835 7.38697 11.3835 7.41663V3.94997H2.78346V10.7166H8.08346C8.0538 10.8166 8.03252 10.918 8.01963 11.0208C8.00663 11.1236 8.00013 11.2264 8.00013 11.3291C8.00013 11.4875 8.00752 11.6481 8.0223 11.8111C8.03719 11.974 8.06869 12.1314 8.1168 12.2833H3.6168L1.2168 14.6833ZM4.03346 6.56663H10.1501V5.19997H4.03346V6.56663ZM4.03346 9.29997H8.15013V7.9333H4.03346V9.29997Z",
    fill: "#172128"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatPasteGoBlack);
export default __webpack_public_path__ + "static/media/chat_paste_go_black.c0aa6c6caa702780cfb624f82239838c.svg";
export { ForwardRef as ReactComponent };